import React from 'react';
import { useSharedState } from '../hooks/SharedStateContext';

// Import the existing components
import ConversationWT from './ConversationWT';
import Conversation from './Conversation';
import ConversationToggle from './ConversationToggle';
import Recording from './Recording';

function MainContent({ isRealtime, hasTimeLimitExceeded }) {
  const { sharedState } = useSharedState();

  // If time limit exceeded, always show upgrade
  if (hasTimeLimitExceeded) {
    const Upgrade = require('./Upgrade').default;
    return <Upgrade />;
  }

  // Switch content based on currentView
  switch (sharedState.currentView) {
    case 'activities':
    case 'conversation':
    default:
      // Let the original components handle activities and conversation
      return isRealtime ? (
        <>
          <Conversation />
          <ConversationToggle />
        </>
      ) : (
        <>
          <ConversationWT />
          <Recording />
        </>
      );
  }
}

export default MainContent;